<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div class="block">
        <yz-daterange @dateRange="getChooseTime"></yz-daterange>
        <el-input v-model.trim="inputVal" class="input_s200" placeholder="请输入会员卡号/套餐名称" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
        </el-input>
        <el-button class="ml_20" type="primary" @click="exportList">导出Excel</el-button>
      </div>
      <div class="commonInfo">
        <div class="content">
          <h3>时间：{{ value?value[0]:'' }}~{{ value?value[1]:'' }}</h3>
          <h3>收入总额：{{ total ? total.toFixed(2) : '0.00' }}元</h3>
        </div>
      </div>
      <div class="commonTable">
        <el-table :data="tableData" tooltip-effect="light">
          <el-table-column prop="paytime" :show-overflow-tooltip="true" label="时间">
          </el-table-column>
          <el-table-column prop="cardno" :show-overflow-tooltip="true" label="会员卡号">
          </el-table-column>
          <el-table-column prop="packagename" :show-overflow-tooltip="true" label="套餐名称">
          </el-table-column>
          <el-table-column prop="resultamount" :show-overflow-tooltip="true" label="消费金额（元）">
          </el-table-column>
          <el-table-column prop="dutyName" :show-overflow-tooltip="true" label="操作人">
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <yz-btn type="primary" @click="projectEdit(scope.row.id)">详情</yz-btn>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="tableData.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="currentPage" :page-size="10" layout="prev, pager, next, jumper" :total="pageCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <gt-footer></gt-footer>
    <gt-details @tansferPhone="getDetailsData"></gt-details>
  </div>
</template>

<script>
import { getTcgm } from '../../api';

export default {
  data() {
    return {
      value: '', // 时间段
      inputVal: '', // 搜索值
      currentPage: 1,
      tableData: [], // 套餐购买记录列表
      pageNum: 1,
      pageCount: 1,
      total: '', // 收入总额
      detailsData: { // 套餐购买详情
        memberId: '',
        urlStatus: '',
        detailsDialog: false
      }
    };
  },
  activated() {
    this.getListData();
  },
  methods: {
    // 得到子组件选择的时间
    getChooseTime(time) {
      this.value = time;
      this.chooseTime(time);
    },
    // 选择时间段
    chooseTime() {
      this.pageNum = 1;
      this.currentPage = 1;
      this.getListData();
    },
    // 搜索--套餐购买记录
    search() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.currentPage = 1;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 导出列表
    exportList() {
      const vm = this;
      if (vm.value) {
        window.location.href = `${this.Lib.A()
        }/erp/lookExport/exportPackage?startDate=${
          vm.value[0]
        }&endDate=${
          vm.value[1]
        }&keyWord=${
          vm.inputVal}`;
      } else {
        window.location.href = `${this.Lib.A()
        }/erp/lookExport/exportPackage?keyWord=${
          vm.inputVal}`;
      }
    },
    // 套餐购买记录
    getListData() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        keyWord: vm.inputVal,
        pageNum: vm.pageNum
      };
      if (vm.value) {
        data.startDate = vm.value[0];
        data.endDate = vm.value[1];
      }
      getTcgm(data).then((res) => {
        if (res.data) {
          vm.tableData = res.data.orderList;
          vm.total = res.data.total;
          vm.pageCount = res.data.pageCount * 10;
        } else {
          vm.tableData = [];
          vm.total = 0;
          vm.pageCount = 1;
        }
      });
    },
    // 赋值组件数据
    getDetailsData(list) {
      this.detailsData = list;
    },
    projectEdit(id) {
      this.detailsData.memberId = id;
      this.detailsData.urlStatus = '3';
      this.detailsData.detailsDialog = true;
    }
  }
};
</script>
